<div id="register" class="inner-scroll" fxLayout="row" fxLayoutAlign="start">

  <div id="register-form-wrapper" fxFlex="30" [@animate]="{value:'*',params:{delay:'300ms',x:'100%'}}">

    <div id="register-form">

      <div class="logo" fxHide.gt-xs>
        <img src="assets/images/logos/logo_ezycharge_main.png">
      </div>

      <div class="title" style="color: #ffffff;">Create An Account</div>

      <form class="form-scroll" name="registerForm" [formGroup]="registerForm" novalidate>
        <div *ngIf="hideDetail" fxLayout="column" fxLayoutAlign="start" fxFlex="1 0 auto" name="form">
          <div fxLayout="row " fxLayoutAlign="start center" fxLayoutGap="20px" fxFlex="1 0 auto">
            <mat-form-field appearance="outline" fxFlex="50" class="pr-4">
              <mat-label>First Name</mat-label>
              <input matInput placeholder="" formControlName="f_name" required>
              <mat-icon style="color:#1c5483 !important" matSuffix>person</mat-icon>
              <mat-error *ngIf="registerForm.get('f_name').invalid">Please enter first name</mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline" fxFlex="50" class="pr-4">
              <mat-label>Middle Name</mat-label>
              <input matInput placeholder="" formControlName="m_name" required>
              <mat-icon style="color:#1c5483 !important" matSuffix>person</mat-icon>
              <mat-error *ngIf="registerForm.get('m_name').invalid">Please enter last name</mat-error>
            </mat-form-field>
          </div>
          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px" fxFlex="1 0 auto">
            <mat-form-field appearance="outline" fxFlex="50" class="pr-4">
              <mat-label>Last Name</mat-label>
              <input matInput placeholder="" formControlName="l_name" required>
              <mat-icon style="color:#1c5483 !important" matSuffix>person</mat-icon>
              <mat-error *ngIf="registerForm.get('l_name').invalid">Please enter last name</mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline" class="pr-4" fxFlex="50">
              <mat-label>Username</mat-label>
              <input matInput placeholder="" formControlName="username" required style="text-transform: none;">
              <mat-icon style="color:#1c5483 !important" matSuffix>account_circle</mat-icon>
              <mat-error *ngIf="registerForm.get('username').invalid">Please enter name</mat-error>
            </mat-form-field>

          </div>
          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px" fxFlex="1 0 auto">
            <mat-form-field appearance="outline" class="pr-4" fxFlex="50">
              <mat-label>Email</mat-label>
              <input matInput placeholder="" formControlName="email" required style="text-transform: none;">
              <mat-icon style="color:#1c5483 !important" matSuffix>email</mat-icon>
              <mat-error *ngIf="registerForm.get('email').invalid">Please enter email</mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline" class="pr-4" fxFlex="50">
              <mat-label>Mobile No</mat-label>
              <input matInput placeholder="" type="number" formControlName="MobNo" required>
              <mat-icon style="color:#1c5483 !important" matSuffix>smartphone</mat-icon>
              <mat-error *ngIf="registerForm.get('MobNo').hasError('required')">Mobile Number is Required
              </mat-error>
              <mat-error *ngIf="registerForm.get('MobNo').hasError('pattern')">Mobile number must be 10 digit
              </mat-error>

            </mat-form-field>
          </div>
          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px" fxFlex="1 0 auto">
            <mat-form-field appearance="outline" class="pr-4" fxFlex="50">
              <mat-label>Alternate Mobile Number</mat-label>
              <input matInput placeholder="" type="number" formControlName="u_altmobile">
              <mat-error *ngIf="registerForm.get('u_altmobile').invalid">Please enter alternate mobile no</mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline" class="pr-4" fxFlex="50">
              <mat-label>Password</mat-label>
              <input matInput placeholder="" [type]="isPasswordFieldType ? 'text' : 'password'"
                formControlName="password" required style="text-transform: none;">
              <mat-icon (click)="togglePasswordFieldType()" style="color:#1c5483 !important" matSuffix>
                {{isPasswordFieldType ? 'visibility_off' :
                'visibility'}}</mat-icon>
              <mat-error *ngIf="registerForm.get('password').invalid">Please enter password</mat-error>
            </mat-form-field>
          </div>

          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px" fxFlex="1 0 auto">
            <mat-form-field appearance="outline" class="pr-4" fxFlex="50">
              <mat-label>Confirm Password</mat-label>
              <input matInput placeholder="" [type]="isPasswordConfirmFieldType ? 'text' : 'password'"
                formControlName="confirmPassword" required style="text-transform: none;">
              <mat-icon (click)="togglePasswordConfirmFieldType()" style="color:#1c5483 !important" matSuffix>
                {{isPasswordConfirmFieldType ?
                'visibility_off' : 'visibility'}}</mat-icon>
              <mat-error *ngIf="registerForm.get('confirmPassword').hasError('required')">Please confirm
                your password!
              </mat-error>
              <mat-error *ngIf="registerForm.get('confirmPassword').hasError('confirm')">Password is
                inconsistent!
              </mat-error>
            </mat-form-field>
          </div>

          <div fxLayout="row wrap" fxLayoutGap="8px grid">
            <div fxFlex="100" fxFlex.lt-sm="100">
              <button mat-raised-button class="submit-button" color="accent" mat-raised-button color="primary"
                [disabled]="registerForm.invalid" (click)="register()">Proceed </button>
            </div>

          </div>

          <div class="remember-forgot-password" *ngIf="isSuccessMessage" fxLayout="row" fxLayout.xs="column"
            fxLayoutAlign="space-between center">
            <mat-error style="color:white"> <b> {{successMessage}}</b></mat-error>
          </div>
          <div class="remember-forgot-password" *ngIf="isErrorMessage" fxLayout="row" fxLayout.xs="column"
            fxLayoutAlign="space-between center">
            <mat-error> <b> {{errorMessage}}</b></mat-error>
          </div>
        </div>
        <div *ngIf="validateOTP" fxLayout="row wrap" fxLayoutGap="8px grid">
          <div fxFlex="100" fxFlex.lt-sm="100" style="text-align:end">
            <mat-form-field appearance="outline">
              <mat-label>OTP</mat-label>
              <input matInput formControlName="otp">
            </mat-form-field>
          </div>
          <div fxFlex="100" fxFlex.lt-sm="100" style="text-align:end">
            <span><a style="font-size:14px;cursor: pointer;text-decoration: underline;" (click)="resendOTP()">Resend
                OTP</a></span>
          </div>

          <div fxFlex="100" fxFlex.lt-sm="100">
            <button mat-raised-button class="submit-button" color="accent" mat-raised-button color="primary"
              (click)="vaidateOTP()">Validate OTP</button>
          </div>
          <div class="remember-forgot-password" *ngIf="isSuccessMessage" fxLayout="row" fxLayout.xs="column"
            fxLayoutAlign="space-between center">
            <mat-error style="color:white"> <b> {{successMessage}}</b></mat-error>
          </div>
          <div class="remember-forgot-password" *ngIf="isErrorMessage" fxLayout="row" fxLayout.xs="column"
            fxLayoutAlign="space-between center">
            <mat-error> <b> {{errorMessage}}</b></mat-error>
          </div>
        </div>
      </form>
      <div class="register" fxLayout="column" fxLayoutAlign="start start">
        <span class="text" style="color: white;">Already have an account?</span>
        <a class="link" [routerLink]="'/login'">Login</a>
      </div>
      <div class="forgot-password" fxLayout="column" style="position:absolute;bottom: 10px;color:#ffffff; ">
        <div fxLayout="row" fxLayoutAlign="start start" fxFlex="1 0 auto" name="form" style="margin-bottom: 10px;">
          <div fxFlex="100">
            <a href="#" style="font-size:  0.8em ;" target="_blank">About Us</a>&nbsp;&nbsp;
            <a href="#" style="padding-left:5px;font-size:  0.8em;" target="_blank">Contact
              Us</a>&nbsp;&nbsp;
            <a href="#" style="padding-left:5px;font-size:  0.8em;" target="_blank">Privacy & Policy</a>
          </div>
        </div>
        <div fxLayout="row" fxLayoutAlign="start start" fxFlex="1 0 auto" name="form" style="margin-bottom: 10px;">
          <div fxFlex="100">
            <a href="#" style="padding-bottom:5px;font-size:  0.8em;" target="_blank">Product
              Services</a>&nbsp;&nbsp;
            <a href="#" style="padding-left:5px;font-size: 0.8em;" target="_blank">Refund & Cancellation
              Policy</a>
          </div>

        </div>

        Powered By Ezy Charge. Version(1.0.1)
      </div>
    </div>

  </div>

  <div id="v-line"></div>

  <div id="register-intro" fxFlex="70" fxHide fxShow.gt-xs>

    <div class="logo" [@animate]="{value:'*',params:{scale:'0.2'}}">
      <img src="assets/images/logos/logo_ezycharge_main.png">
    </div>

    <div class="title" [@animate]="{value:'*',params:{delay:'50ms',y:'25px'}}">
      Welcome to the Ezy Charge!
    </div>

    <div class="description" [@animate]="{value:'*',params:{delay:'100ms',y:'25px'}}">
      We are powering next generation mobility by delivering innovative EV charging infrastructure and
      Li-ion batteries for all segments of vehicles.
    </div>

  </div>